var _filter, _clipPath, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgS1916Ele(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 1920,
    viewBox: "0 0 1080 1920",
    width: 1080,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 358.797,
    width: 1191.8,
    x: -56.3984,
    y: 1579.52
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.918
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 43.6992
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.92549 0 0 0 0 0.494118 0 0 0 0 0.694118 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_2747_161263"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2747_161263",
    mode: "normal",
    result: "shape"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h1920v1080h-1920z",
    transform: "matrix(0 1 -1 0 1080 0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fae9f2",
    height: 184,
    rx: 81.4395,
    width: 1017,
    x: 31,
    y: 1655
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ea0d8b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m53.6903 1691.95c-8.0377.15-13.8029-5.02-13.9563-12.95-.106-5.48 1.6002-11.74 6.8502-23.74l6.6457-15.43c.5261-1.14 1.6075-1.91 2.8862-1.94l8.9511-.17c1.644-.03 2.5793 1.08 2.0642 2.79l-7.9098 25.65c4.7897 1.98 7.9829 6.45 8.0925 12.12.1498 7.74-5.4035 13.51-13.6238 13.67zm34.8906-.68c-8.0376.16-13.8028-5.02-13.9562-12.95-.106-5.47 1.6002-11.74 6.8502-23.73l6.6457-15.43c.5261-1.14 1.6075-1.92 2.8862-1.94l8.951-.18c1.6442-.03 2.5792 1.09 2.0642 2.79l-7.9097 25.65c4.7897 1.99 7.9827 6.46 8.0927 12.12.15 7.74-5.4037 13.51-13.6241 13.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1024 1807.1c8.04-.15 13.81 5.02 13.96 12.95.11 5.48-1.6 11.74-6.85 23.74l-6.65 15.43c-.52 1.14-1.6 1.92-2.88 1.94l-8.95.17c-1.65.04-2.58-1.08-2.07-2.79l7.91-25.65c-4.79-1.98-7.98-6.45-8.09-12.12-.15-7.74 5.4-13.51 13.62-13.67zm-34.888.68c8.038-.16 13.808 5.02 13.958 12.95.1 5.47-1.6 11.74-6.852 23.74l-6.645 15.42c-.526 1.15-1.608 1.92-2.886 1.95l-8.951.17c-1.645.03-2.58-1.08-2.065-2.79l7.91-25.65c-4.79-1.99-7.983-6.46-8.092-12.12-.15-7.74 5.403-13.51 13.623-13.67z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS1916Ele);
export default __webpack_public_path__ + "static/media/S1_9_16_ELE.b5c3252fb2d46e77c8dc8f99551ab0b9.svg";
export { ForwardRef as ReactComponent };